import React from 'react';
import { View, TouchableOpacity, StyleSheet, Text } from 'react-native';
import { Entypo, EvilIcons, Feather, FontAwesome, Fontisto, Ionicons, Octicons, } from '@expo/vector-icons';
import {AppMain, FontInfo, ReturnTypes } from '../~Utilities/Constants';
import Popup from './Popup';
import TextInputEx from '../C_Text/TextInputEx';
import { Connection, ConnectionMkt, ConnectionOrd } from '../~Utilities/Connection';
import RNPickerSelect from "react-native-picker-select";

/*   ---------------------------------------------------------------------   */

export interface ISearch
{
  text:         string;
  sFromToken? : string;
}

/*   ---------------------------------------------------------------------   */

export default class Search extends React.Component
 {
   public oTxtSearch : TextInputEx | null = null;
   public oPopup     : Popup       | null = null;
   
   /*   -------------------------------------------------------------------   */

   state : ISearch = {text:"", sFromToken: undefined}

   /*   -------------------------------------------------------------------   */
   
    constructor(props)
    {
    super(props);

    this.Show             = this.Show.bind(this);
    this.Hide             = this.Hide.bind(this);
    this.HideNoAnimation  = this.HideNoAnimation.bind(this);

    this.state = {text: "", sFromToken: AppMain.sDef_Symbol};
    }

    /*   ---------------------------------------------------------------------   */

    Show(sText : string = "")
    {
    this.oPopup?.Show();
    this.oTxtSearch?.SetFocus(); 

    if (this.state.text != sText)
      this.setState({text:sText});

    if ((!AppMain.sDef_Symbol || !Connection.oStore.has(AppMain.sDef_Symbol)) 
         && Connection.oSettings.length > 0)
      {
      ConnectionOrd.SetDefSymbol(Connection.oSettings[0].token);
      }

    this.forceUpdate();
    }

    /*   ---------------------------------------------------------------------   */

    Hide()
    {
    this.oPopup?.Hide();
    }

    /*   ---------------------------------------------------------------------   */

    HideNoAnimation()
    {
    this.oPopup?.HideNoAnimation();
    }

    /*   ---------------------------------------------------------------------   */

    componentDidMount() 
    {
    }

    componentWillUnmount() 
    {
    }

   /*   ---------------------------------------------------------------------   */ 
   
    componentDidUpdate()
    {
    }

   /*   ---------------------------------------------------------------------   */ 

   GetSymbols()
   {
     let oSymbols = new Array(0);
 
     for (let [key, value] of Connection.oStore.entries())
       {
        oSymbols.push({label:value.token, value:key, key:key, color:"black"});
 
       //Utilities.Sendlog("adding key: " + key);
       }
 
     // if (!this.state.pos_data)
     //   {
     //   let oPosData = this.GetData();
 
     //   if (oPosData != undefined)
     //     this.setState({pos_data:oPosData});
 
     //   Utilities.Sendlog("acc key: " + oPosData?.acc_key + " size: " + oAccs.length);
     //   }
 
     //if (oAccs.length == 0)
     //  oAccs.push({label:"21", value:"2", key:"2"});
 
     return(oSymbols);
   }
 
   /*   -------------------------------------------------------------------   */
 
   render() 
   {
   if (!ConnectionMkt.IsLoggedIn())  
   return(null);

   else return(
    <Popup ref={node => { this.oPopup = node; }}> 
    <View style={{alignItems:'center', backgroundColor:'transparent', marginHorizontal:0, paddingTop:20}}>

    <TextInputEx
          ref={node => 
            { 
              this.oTxtSearch = node; 
            }}

          getstyle= {()=>{return( this.oTxtSearch?.state.error == ReturnTypes.ERR_INVALID? 
                          [FontInfo.appStyles.txt_bold, styles.search_input_invalid, {borderColor:FontInfo.sBorder, color:FontInfo.sForeground, borderBottomColor:FontInfo.sBorder, fontSize:FontInfo.iFontSize+5}] : 
                          [FontInfo.appStyles.txt_bold, styles.search_input, {borderColor:FontInfo.sBorder, color:FontInfo.sForeground, borderBottomColor:FontInfo.sBorder, fontSize:FontInfo.iFontSize+5}])}}
          placeholder= {this.state.text? "replace \"" + this.state.text + "\"" : "enter such as aapl.q, es.cme"}
          placeholderTextColor="grey"
          //initValue={"init"}

          autoFocus={true}
          autoCorrect={false}
          spellCheck={false}
          autoCompleteType='off'

          //removeClippedSubviews={false}
    
          // onChangeText={text=>{}}
          //onBindTxtEvent={BindSearch}

          onSubmitEditing={()=>
                  {
                  //alert(oTxtSearch?.GetText1());
                  let iErr = ConnectionMkt.GetSymbolInfo(this.oTxtSearch?.GetText(), 
                                                         "", 
                                                         this.state.text); 
                  //alert("txt submit: " + iErr);
                  this.oTxtSearch?.UpdateError(iErr);
                  }}
      />


      <View style={{backgroundColor:'transparent', marginTop:20, flexDirection:'column', alignSelf:'center', width:'100%'}}>
      {/* <Text style={{alignSelf:'center', fontSize:28, color:FontInfo.sForeground}}>↑</Text> */}
      {/* <Text style={{alignSelf:'center', fontSize:24, color:FontInfo.sForeground}}>sa⚙️dssd</Text> */}
      {/* <Feather name="arrow-up" size={24} style={{alignSelf:'center'}} color={FontInfo.sForeground} /> */}
      {/* <Ionicons name="settings-sharp" size={22} style={{alignSelf:'center'}} color={FontInfo.sForeground} /> */}

      <View style={{backgroundColor:'transparent', flexDirection:'row', alignSelf:'center'}}>
      {/* <FontAwesome name="gear" size={18} style={{alignSelf:'center', marginTop:2}} color={FontInfo.sForeground}/>       */}
      <Text style={[FontInfo.appStyles.txt_bold, {fontSize:FontInfo.iFontSize+2, marginRight:2, color:FontInfo.sForeground}]}>Copy</Text>
      {/* <EvilIcons name="gear" size={22} style={{alignSelf:'center'}} color={FontInfo.sForeground} /> */}
      {/* <FontAwesome name="gear" size={18} style={{alignSelf:'center', marginTop:2}} color={FontInfo.sForeground}/>*/}
      <Ionicons name="settings-outline" size={18} style={{alignSelf:'center', marginTop:1}} color={FontInfo.sForeground} />
      <Text style={[FontInfo.appStyles.txt_bold, {fontSize:FontInfo.iFontSize+2, marginLeft:3, color:FontInfo.sForeground}]}>from</Text>
      </View>
      {/* <FontAwesome name="gear" size={24} color={FontInfo.sForeground} /> */}
      {/* <Octicons name="gear" size={24} color={FontInfo.sForeground} /> */}
      

      <RNPickerSelect
                 key={Connection.oStore.size}
                 style={GetPickerStyles()}
                 onValueChange={(sValue, iIndex) => 
                    {  
                      this.setState({sFromToken:sValue}); 

                      ConnectionOrd.SetDefSymbol(sValue);
                    }}
                 useNativeAndroidPickerStyle={false}
                 fixAndroidTouchableBug={true}
                 placeholder={{}}
                 items={this.GetSymbols()}
                 //itemKey={this.state.pos_data?.acc_key}
                 value={this.state.sFromToken} />


      </View>

      <View style={{ flexDirection: 'row', alignSelf: 'center', backgroundColor:'transparent' }}>
    
      <TouchableOpacity
            style={[styles.button_plus, {}]}
            
            onPress={()=>
              {
              //alert(oTxtSearch?.GetText1());
              let iErr = ConnectionMkt.GetSymbolInfo(this.oTxtSearch?.GetText(), 
                                                     "", 
                                                     this.state.text); 

              //alert("button submit: " + iErr);
              this.oTxtSearch?.UpdateError(iErr);
              }}
          >
     
      
      <Entypo name="cycle" style={this.state.text? {marginBottom: -1, } : {display:'none'}} size={30} color="white" />
      <FontAwesome style={!this.state.text? { marginBottom: -3, } : {display:'none'}} name="plus" size={30} color="white" />
    
      {/* <Text>{new Date().toTimeString()}</Text> */}
    
      </TouchableOpacity>
      </View>

    </View>
    </Popup>
    );

     }
}

/*   =====================================================================   */

function GetPickerStyles()
{
return(

  StyleSheet.create({
    inputWeb: {
      alignSelf:'center',
      fontFamily: FontInfo.iFont >= 0? FontInfo.Fonts[FontInfo.iFont].normal : undefined,
      fontSize: FontInfo.iFontSize + 2,
      //fontWeight:'bold',
      //paddingVertical: 12,
      //paddingLeft: 40,
  
      // marginLeft:5,
      //width:200,
      //marginVertical:20,

      //paddingLeft: 40,
      marginTop:5,
      height:40,
      minWidth:100,
      textAlign:'center',
  
      marginHorizontal:14,
      marginBottom:8,
      borderWidth: 1,
      borderColor: FontInfo.sBorder,
      borderRadius: 10,
  
      // borderWidth: 1,
      // borderColor: '#EEEEEE',
      // borderRadius: 4,
      // borderBottomWidth:0,
      // borderBottomColor:'#EEEEEE',
      // borderBottomEndRadius:0,
      // borderBottomStartRadius:0,
  
  
      backgroundColor:'transparent',
      color: FontInfo.sForeground,
      //paddingRight: 30, // to ensure the text is never behind the icon
    },
  
    inputIOS: {
      alignSelf:'center',
      fontFamily: FontInfo.iFont >= 0? FontInfo.Fonts[FontInfo.iFont].normal : undefined,
      fontSize: FontInfo.iFontSize + 2,
      //fontWeight:'bold',
      //paddingVertical: 12,
  
  
      //marginVertical:20,
      // marginLeft:5,
      paddingLeft: 30,
      marginTop:10,
      height:40,
      width:272,
      textAlign:'center',
  
      marginHorizontal: FontInfo.iFontSize + 2,
      marginBottom:8,
      borderWidth: 1,
      borderColor: FontInfo.sBorder,
      borderRadius: 10,
      // borderBottomWidth:0,
      // borderBottomColor:'#EEEEEE',
      // borderBottomEndRadius:0,
      // borderBottomStartRadius:0,
  
      backgroundColor:'transparent',
      color: FontInfo.sForeground,
      paddingRight: 30, // to ensure the text is never behind the icon
    },
    inputAndroid: {
      alignSelf:'center',
      fontFamily: FontInfo.iFont >= 0? FontInfo.Fonts[FontInfo.iFont].normal : undefined,
      // alignSelf:'center',
      fontSize: FontInfo.iFontSize + 2,
      //fontWeight:'bold',
      // paddingLeft: 20,
      //paddingVertical: 12,
      //paddingLeft: 30,
  
      //marginVertical:20,
  
      // marginLeft:5,
      paddingLeft: 30,
      marginTop:10,
      height:40,
      width:272,
      textAlign:'center',
  
      marginHorizontal:14,
      marginBottom:8,
      borderWidth: 1,
      borderColor: FontInfo.sBorder,
      borderRadius: 10,
  
      // borderWidth: 0,
      // borderBottomWidth:0,
      // borderBottomColor:'#EEEEEE',
      // borderBottomEndRadius:0,
      // borderBottomStartRadius:0,
      // textAlign:'center',
      // borderWidth: 0.5,
      // borderColor: 'purple',
      // borderRadius: 8,
      backgroundColor:'transparent',
      color: FontInfo.sForeground,
      paddingRight: 30, // to ensure the text is never behind the icon
    },
  
    // button_order:
    // {
    //   backgroundColor:'#f5f6fa',
    //   margin:10,
    //   padding:8,
    //   borderRadius:10,
    //   minWidth:90,
    // },
  
    // text_order:
    // {
    // alignSelf:'center',
    // fontWeight:'bold',
    // color:'red'
    // },
  
  })  

);  
}

/*   =====================================================================   */

const styles = StyleSheet.create({
   search_input: 
  {
  alignSelf:'center',
  //fontSize: FontInfo.iFontSize + 4,
  height: 44,
  width:260,
  borderWidth: 0,
  margin:4,
  padding:10,
  paddingLeft:4,
  borderColor:'white',
  borderBottomWidth:1,
  //borderBottomColor:FontInfo.sDivider,//'#EEEEEE',
  //backgroundColor:'transparent',
  //color:FontInfo.sForeground,
  },

  search_input_invalid: 
  {
  alignSelf:'center',
  //fontSize: FontInfo.iFontSize + 4,
  height: 44,
  borderWidth: 0,
  margin:4,
  padding:10,
  paddingLeft:4,
  width:260,
  borderColor:'white',
  borderBottomWidth:1,
  //borderBottomColor:'red',
  //backgroundColor:'transparent',//'#ffe4e1',
  //color:FontInfo.sForeground,
  },

  button_plus: 
  {
  width:70,
  height:70,
  alignSelf: 'center',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: 35,
  backgroundColor: 'cornflowerblue',
  padding:20,
  margin:10,
  },

});